import {
  NBS_API_GET_QUICK_MATCHES_SUCCESS,
  NBS_API_INVITE_ACTION_SUCCESS,
  NBS_API_GET_ADS_SUCCESS,
  SET_QUICK_MATCHES_ADS,
  SET_SHOWING_INDEX_QUICK_MATCH_AD,
  QUICK_MATCH_OPTIMISTIC_ADVANCE,
} from '../../constants/actions';

const initialState = {
  ads: [],
  data: [],
  showStartOver: undefined,
  currentQuickMatchIndex: 0,
  undoUserId: null,
  matchedUser: {},
  indexOfLastShowedAd: -1,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_QUICK_MATCHES_SUCCESS:
      const currentState = { ...state };
      const { matches } = action.response;
      return {
        ...currentState,
        showStartOver: action.response.show_start_over,
        data: action.startOver ? matches : [...currentState.data, ...matches],
        indexOfLastShowedAd: -1,
      };
    case QUICK_MATCH_OPTIMISTIC_ADVANCE:
      // Like/pass advances the card immediately (before the API responds).
      return {
        ...state,
        currentQuickMatchIndex: state.currentQuickMatchIndex + 1,
        undoUserId: action.userId,
      };
    case NBS_API_INVITE_ACTION_SUCCESS:
      // Like/pass already advanced optimistically (above); only undo (action 3)
      // moves the index back here.
      if (action.data.user_action === 3) {
        return {
          ...state,
          currentQuickMatchIndex:
            state.currentQuickMatchIndex > 0
              ? state.currentQuickMatchIndex - 1
              : 0,
          undoUserId: null,
        };
      }
      return state;
    case NBS_API_GET_ADS_SUCCESS:
      return {
        ...state,
        indexOfLastShowedAd: -1,
      };
    case SET_SHOWING_INDEX_QUICK_MATCH_AD:
      return {
        ...state,
        indexOfLastShowedAd: action.index,
      };
    case SET_QUICK_MATCHES_ADS:
      return {
        ...state,
        ads: [...state.ads, ...action.data],
      };
    default:
      return state;
  }
}
